import React, { useEffect, useMemo } from "react";
import { io } from "socket.io-client";
import { socketURL } from "../axios";

const Context = React.createContext(null);
const SocketContext = ({ children }) => {

  const socket = useMemo(() =>
    io(socketURL, {
      cors: {
        origins: '*:*',
        methods: ["GET", "POST"],
        credentials: true,
      },
    })
    , [socketURL]);
  useEffect(() => {
    console.log(`[SocketContext] Connecting to: ${socketURL}`);
    socket.connect();
    socket.on("connection", (messg) => {
      console.log("Socket connected", messg);
    });
  }, [socket, socketURL]);
  return <Context.Provider value={{ socket }}> {children} </Context.Provider>;
};

export const useSocketContext = () => {
  return React.useContext(Context);
};
export default SocketContext;
